import React, { useState } from 'react';
import { Button } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import Text from '../../../../../components/common/Text';
import Paragraph from '../../../../../components/common/Paragraph';

export default function TermsAndConditions() {
  const [isModalVisible, setModalVisible] = useState(false);

  const openModal = () => setModalVisible(true);

  const hideModal = () => setModalVisible(false);

  const modalFooter = (
    <Button type="primary" onClick={hideModal}>
      Entendido
    </Button>
  );

  return (
    <>
      <Modal visible={isModalVisible} footer={modalFooter} width={1000} onCancel={hideModal}>
        <h2>1. Introducción.</h2>

        <Paragraph>
          De conformidad a lo señalado en la Norma de Carácter General Nº 380, de 9 de marzo de
          2015, de la Comisión para el Mercado Financiero o aquella que la modifique o reemplace, el
          Contrato de Condiciones Generales a que se refiere la citada Norma de Carácter General,
          sus Anexos, así como los contratos que se suscriban para la contratación de un servicio
          y/o producto podrán ser suscritos de manera electrónica, debiendo quedar una copia del
          documento en poder del Cliente. Agrega la misma Norma de Carácter General que los procesos
          electrónicos, sonidos o símbolos que sean empleados en los contratos suscritos mediante
          firma electrónica para identificar formalmente al Cliente deberán haber sido previamente
          acordados entre la Corredora y el Cliente.
        </Paragraph>
        <Paragraph>
          Por su parte, la Ley Nº 19.799 sobre &quot;Documentos Electrónicos, Firma Electrónica y
          Servicios de Certificación de dicha Firma&quot; define en la letra f) del artículo segundo
          por firma electrónica, cualquier sonido, símbolo o proceso electrónico, que permite al
          receptor de un documento electrónico identificar al menos formalmente a su autor. Por su
          parte, la letra d) del citado precepto legal define por documento electrónico, toda
          representación de un hecho, imagen o idea que sea creada, enviada, comunicada o recibida
          por medios electrónicos y almacenada de un modo idóneo para permitir su uso posterior.
        </Paragraph>
        <Paragraph>
          La presente Política de Enrolamiento, Envío de Órdenes de Operaciones y Comunicaciones
          mediante Sistemas Electrónicos o Digitales tiene por propósito:
        </Paragraph>

        <Paragraph>
          a. Definir los casos en que se utilizará la firma electrónica, describiendo el
          procedimiento a utilizar para el enrolamiento de clientes y para las transacciones, actos
          o contratos que sean firmados de forma electrónica utilizando firma electrónica o digital.
        </Paragraph>
        <Paragraph>b. Definir las condiciones para la operación de los clientes.</Paragraph>

        <h2>
          2. Requisitos para operar en Vantrust Capital Corredores de Bolsa S.A. mediante
          utilización de sistemas electrónicos o digitales.
        </h2>
        <Paragraph>
          Para poder operar a través de Vantrust Capital Corredores de Bolsa S.A. utilizando
          sistemas electrónicos o digitales se deben cumplir los siguientes requisitos:
        </Paragraph>
        <Paragraph>
          a. Ser chileno o extranjero con domicilio o residencia en Chile con cédula de identidad de
          la República de Chile vigente.
        </Paragraph>
        <Paragraph>b. Ser mayor de 18 años.</Paragraph>
        <Paragraph>c. Firmar la documentación requerida.</Paragraph>
        <Paragraph>
          d. Disponer de software necesario (Adobe Acrobat Reader o equivalente).
        </Paragraph>
        <h2>3. Procedimiento para la utilización de firma electrónica.</h2>
        <Paragraph>
          3.1. Política de enrolamiento mediante utilización de firma electrónica o digital.
        </Paragraph>
        <Paragraph>
          Todo cliente que desee realizar operaciones con Vantrust Capital Corredores de Bolsa S.A.
          y que cumpla los requisitos indicados en el número 2. precedente, deberá previamente y por
          única vez haberse sometido a un proceso de enrolamiento de cliente en forma física o
          electrónica, en este último caso, el cual deberá cumplir con las exigencias que se definen
          a continuación:
        </Paragraph>
        <Paragraph>3.1.1. Condiciones generales para enrolamiento para firma electrónica</Paragraph>
        <Paragraph>
          El proceso de enrolamiento deberá contar con las medidas de seguridad necesarias para
          acreditar que la persona que se está enrolando como cliente es quien dice ser, para lo
          cual se considerará que al momento de enrolarse ésta deba identificarse de forma adecuada
          por medio de elementos que permitan asegurar su identidad, entre estos: datos personales,
          correo electrónico, cuenta corriente, etcétera.
        </Paragraph>
        <Paragraph>
          De la misma forma, Vantrust Capital Corredores de Bolsa S.A. considerará elementos
          adicionales de seguridad tales como tecnología de verificación biométrica y verificación
          automática de autenticidad del documento de identidad y lectura de datos, u otros afines
          que considere adecuados para tales propósitos.
        </Paragraph>
        <Paragraph>
          3.1.2. Procedimiento de enrolamiento mediante utilización de firma electrónica.
        </Paragraph>
        <Paragraph>
          a. Habiendo el Cliente aceptado los términos y condiciones referidos en la presente
          Política de Enrolamiento, Envío de Órdenes de Operaciones y Comunicaciones mediante
          Sistemas Electrónicos o Digitales, Vantrust Capital Corredores de Bolsa S.A. enviará al
          Cliente el Contrato de Condiciones Generales de Prestación de Servicios a que se refiere
          la Norma de Carácter General Nº 380 de la Comisión para el Mercado Financiero o aquella
          que la modifique o reemplace, junto con sus Anexos, Formularios, Declaraciones y Contratos
          requeridos para operar en los productos y contratos que el Cliente quisiere operar
          (&quot;Set de Enrolamiento&quot;).
        </Paragraph>
        <Paragraph>
          b. Vantrust Capital Corredores de Bolsa S.A. enviará el Set de Enrolamiento a la casilla
          de correo electrónica del Cliente mediante el envío de un link.
        </Paragraph>
        <Paragraph>
          c. El Cliente deberá pinchar el link, revisar el Set de Enrolamiento, leerlo de manera
          completa y así corroborar que sus datos y demás información son correctos, debiendo luego
          proceder a la firma de éste en los casilleros en que se le indique.
        </Paragraph>
        <Paragraph>
          d. Para poder proceder a la firma, se le solicitará al Cliente una verificación facial así
          como el scanner fotográfico de su cédula de identidad por ambos lados; o cualquier otro
          método de seguridad que Vantrust Capital Corredores de Bolsa S.A. considere idóneo para
          efectos de verificar la identidad del Cliente.
        </Paragraph>
        <Paragraph>
          e. Finalmente, el sistema validará al Cliente cotejando su rostro con su cédula de
          identidad.
        </Paragraph>
        <Paragraph>
          f. Efectuada la verificación anterior, el sistema mostrará al Cliente el Set de
          Enrolamiento firmado y foliado de manera que pueda almacenar para su respaldo copia del
          mismo debidamente firmado.
        </Paragraph>
        <Paragraph>
          g. Adicional a lo señalado en la letra f, precedente, el Cliente recibirá en su correo
          electrónico un archivo adjunto con el Set de Enrolamiento debidamente firmado y foliado.
        </Paragraph>
        <Paragraph>
          3.2. Política de operación mediante utilización de firma electrónica o digital
        </Paragraph>
        <Paragraph>3.2.1. A través de correo electrónico.</Paragraph>
        <Paragraph>
          El Cliente podrá impartir mediante correo electrónico las órdenes de operaciones,
          únicamente a través de la casilla de correo electrónico que hubiere registrado en Anexo A
          al Contrato de Condiciones Generales de Prestación de Servicios.
        </Paragraph>
        <Paragraph>
          Para los efectos anteriores, y sin perjuicio que la sola dirección de correo electrónico
          pueda identificar formalmente a su autor, todos los mensajes que las partes intercambien
          entre sí con ocasión de lo dispuesto en este numeral 3.2.1., deberán contener un pie de
          firma en el cual se indique el nombre y apellidos de la persona o apoderado autorizado que
          lo envía.
        </Paragraph>
        <Paragraph>
          El Cliente declara estar en pleno conocimiento de los riesgos asociados a las
          transmisiones a través de correo electrónico, tales como, entre otros, intercepciones,
          falsificaciones, alteraciones, por uso malicioso o no, de información por parte de
          terceros; defectos o interrupciones de la transmisión, asumiendo las consecuencias
          derivadas de casos fortuitos o fuerza mayor no imputables a Vantrust Capital Corredores de
          Bolsa S.A.
        </Paragraph>
        <Paragraph>
          El Cliente declara conocer y aceptar que Vantrust Capital Corredores de Bolsa S.A. sólo
          comprueba la entrada de mensajes electrónicos basándose en las direcciones de correo
          electrónico informados por el Cliente. En todo caso, el Cliente deberá informar sin demora
          a Vantrust Capital Corredores de Bolsa S.A., en caso de que existan motivos para temer que
          terceros no autorizados hayan logrado conocer la dirección de correo electrónico y hagan
          un uso indebido del sistema.
        </Paragraph>
        <Paragraph>
          3.2.2. A través de sistemas electrónicos o digitales, distintos del correo electrónico.
        </Paragraph>
        <Paragraph>
          El Cliente podrá firmar mediante sistemas electrónicos o digitales órdenes de operaciones,
          contratos de operaciones, y en general firmar de la misma forma cualquier otro documento
          en que se requiera la firma del Cliente de conformidad a lo establecido en la normativa
          aplicable o a lo dispuesto en el Contrato de Condiciones Generales de Prestación de
          Servicios y/o sus Anexos.
        </Paragraph>
        <Paragraph>
          Para estos efectos, se seguirá el mismo procedimiento descrito en las letras b., c., f., y
          g. del numeral 3.1.2. precedente. En este sentido, y a discreción de Vantrust Capital
          Corredores de Bolsa S.A., ésta podrá solicitar al Cliente la firma de los documentos
          utilizando sistemas de verificación de aquellos señalados en la letra d. del numeral
          3.1.2. precedente.
        </Paragraph>
        <Paragraph>
          El Cliente declara estar en pleno conocimiento de los riesgos asociados a las
          transmisiones a través de sistemas electrónicos o digitales, tales como, entre otros,
          intercepciones, falsificaciones, alteraciones, por uso malicioso o no, de información por
          parte de terceros; defectos o interrupciones de la transmisión, asumiendo las
          consecuencias derivadas de casos fortuitos o fuerza mayor no imputables a culpa grave de
          la otra parte.
        </Paragraph>
        <Paragraph>
          El Cliente declara conocer y aceptar que Vantrust Capital Corredores de Bolsa S.A. sólo
          comprueba la entrada de mensajes electrónicos basándose en las direcciones de correo
          electrónico informados por el Cliente. En todo caso, el Cliente deberá informar sin demora
          a Vantrust Capital Corredores de Bolsa S.A., en caso de que existan motivos para temer que
          terceros no autorizados hayan logrado conocer la dirección de correo electrónico y hagan
          un uso indebido del sistema.
        </Paragraph>
        <h2>4. Declaraciones del Cliente.</h2>
        <Paragraph>El Cliente declara conocer y aceptar:</Paragraph>
        <Paragraph>
          a. Los términos y condiciones referidos en la presente Política de Enrolamiento, Envío de
          Órdenes de Operaciones y Comunicaciones mediante Sistemas Electrónicos o Digitales que
          definen la utilización de sistema de firma electrónica o digital son de obligatorio
          cumplimiento y aceptación. Al acceder a este sistema de operación, el Cliente se obliga
          según los términos y condiciones que acá aparecen.
        </Paragraph>
        <Paragraph>
          b. Vantrust Capital Corredores de Bolsa S.A. podrá en cualquier tiempo modificar en todo o
          parte los términos y condiciones que dan cuenta la presente Política de Enrolamiento,
          Envío de Órdenes de Operaciones y Comunicaciones mediante Sistemas Electrónicos o
          Digitales, siéndole por tanto plenamente aplicables al Cliente dichas modificaciones tan
          pronto hubiere aceptado las mismas conforme el procedimiento definido en el numeral 3.2.
          precedente. Lo anterior, no obsta sin embargo a las modificaciones que fuere menester
          incorporar conforme requerimiento legal o a solicitud de las entidades fiscalizadoras.
        </Paragraph>
        <Paragraph>
          c. El uso del correo electrónico es de exclusiva responsabilidad del Cliente, así como
          también cualquier orden emitida sin autorización, pérdida, robo, falla, error o hecho
          inusual.
        </Paragraph>
        <Paragraph>
          d. Vantrust Capital Corredores de Bolsa S.A. no será responsable de cualquier daño directo
          o indirecto, previsto o imprevisto, como también toda pérdida o gasto que el Cliente pueda
          sufrir con ocasión de la utilización de sistemas de firma electrónica o digital,
          incluyendo errores de ejecución, omisión, interrupción, defecto, demoras o virus, fallas
          del sistema en línea o suspensión o terminación, siempre que ello no le fuere imputable.
        </Paragraph>
        <Paragraph>
          e. En el evento que el Cliente no tenga fondos suficientes y disponibles para realizar las
          transacciones instruidas, las órdenes no serán cursadas, sin ulterior responsabilidad para
          Vantrust Capital Corredores de Bolsa S.A.
        </Paragraph>
      </Modal>
      <Button type="link" style={{ paddingLeft: 0 }} onClick={openModal}>
        <Text style={{ color: 'black' }} underline>
          Ver Términos y Condiciones
        </Text>
      </Button>
    </>
  );
}
